import angular from 'angular';
import Attribut from './Attribut.data';

angular.module('app.core').factory('Referential', Referential);

export default class Referential {

    constructor(data, ownerType, clientCode) {
        this.id = data.id;
        this.code = data.code;
        this.clientCode = clientCode;
        this.functionalType = data.functionalType;
        this.attributs = [];
        data.attributs.forEach((att, index) => {
            this.attributs.push(new Attribut(att, index));
        })
        this.translationNames = data.translationNames;
        this.providerIdPaths = data.providerIdPaths;
        this.ownerType = ownerType;
        if (data.translationNames && data.translationNames.length > 0) {
            data.translationNames.some(tr => {
                if (tr.code && tr.translation && tr.translation !== '' && tr.code.toLowerCase() === 'fr') {
                    this.name = tr.translation;
                    return true;
                }
            })
        }
        if (!this.name || this.name === '') {
            this.name = data.functionalType;
        }

    }


}
